<template>
  <custom-button
    id="remove-pension-button"
    @click="removePension"
    colour="cfs-button"
    class="border border-grey-4 w-72 rounded-full">
    Remove age pension
  </custom-button>
</template>

<script setup lang="ts">
import CustomButton from '@/components/CustomButton/CustomButton.vue'
import { useRetirementCalculatorStore } from '@/store/pinia/RetirementCalculatorStore'
import { computed } from 'vue'

// Store setup
const retirementCalculatorStore = useRetirementCalculatorStore()

// Computed properties
const noAgePension = computed(() => retirementCalculatorStore.getNoAgePension)

// Methods
const removePension = () => {
  retirementCalculatorStore.setNoAgePension()
}
</script>

<style scoped></style>
